export const LOGIN_ROUTE = '/login';
export const MAIN_ROUTE = '/';
export const NEWS_ROUTE = '/news';
export const DOCTORS_ROUTE = '/doctors';
export const PROMOTIONS_ROUTE = '/promotions';
export const POST_ROUTE = '/post';
export const SETTINGS_ROUTE = '/settings';
export const CHAT_ROUTE = '/chats';
export const POINTSHISTORY_ROUTE = '/pointshistory';
export const MAILING_ROUTE = '/mailing';
export const REVIEWS_ROUTE = '/reviews';
export const RATING_ROUTE = '/rating';
export const PATIENTS_ROUTE = '/patients';
export const REPORTS_ROUTE = '/patients/reports';
export const EXAMPLES_ROUTE = '/examples';
export const ACADEMY_ROUTE = '/academy';
export const COURSE_ROUTE = '/course';
export const LESSON_ROUTE = '/lesson';
export const ACCOUNT_PAYMENT = '/PaymentPage';
export const CASCADE_ROUTE = '/cascade';
export const ACCESS_DENIED = '/accessdenied';
export const ADMINS_REFERRAL_ROUTE = '/adminsreferrals';
